import React from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";

const Privacy = () => {
  return (
    <>
    {/* <Header/> */}
    <IndiaBoatsTopBar />
      <PremiumNavbar />
    <>
  <div className="breadcumb-wrapper" style={{ padding: "50px 0" }}>
    <div className="container">
      <div className="breadcumb-content">
        <h1 className="breadcumb-title">Privacy Policy</h1>
        {/* <ul class="breadcumb-menu">
          <li><a href="home-travel.html">Home</a></li>
          <li>About Tourm</li>
      </ul> */}
      </div>
    </div>
  </div>
  {/*======== / Hero Section ========*/}
  {/*==============================
Booking Area  
==============================*/}
  {/*==============================
About Area  
==============================*/}
  <div
    className="about-area position-relative overflow-hidden overflow-hidden space"
    style={{ padding: "30px 0" }}
    id="about-sec"
  >
    <div className="container">
      <div className="row">
        <div className="col-xl-12">
          <div>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              Thank you for visiting the website of Aquartia Pvt. Ltd. group.
              www.indiaboats.in
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              The Privacy Policy is applicable to the websites of Aquartia Pvt.
              Ltd. ('indiaboats.in') comprises of indiaboats.in, this privacy
              statement does not apply to the websites of our business partners,
              corporate affiliates or to any other third parties, even if their
              websites are linked to Indiaboats Website. We recommend you review
              the privacy statements of the other parties with whom you
              interact.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              For the purposes of this privacy policy, "corporate affiliates"
              means any entity or joint venture that is wholly or partially
              owned or controlled by Aquartia Pvt. Ltd. "Business partners"
              means any subcontractor, vendor or other entity with whom we have
              an ongoing business relationship to provide products, services, or
              information.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              The following terms governs the collection, use and protection of
              your Personal Information by the Website. This Privacy Policy
              shall be applicable to users or customers who purchases any
              product or services from the Website or visits the Website. By
              visiting and/ or using the Website you have agreed to the
              following Privacy Policy.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Introduction: </strong>
              <br />
              As a registered member of the Website and/or as a visitor (if
              applicable and as the case may be), you will be entitled to
              savings and benefits on boats / yacht charters, Equipments,
              reservations, services In addition, look forward to receiving
              monthly newsletters and exclusive promotions offering special
              deals.
              <br />
              That's why we've provided this Privacy Policy, which sets forth
              our policies regarding the collection, use and protection of the
              Personal Information of those using or visiting the Website.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Personal Information: </strong>
              <br />
              Personal Information means and includes all information that can
              be linked to a specific individual or to identify any individual,
              such as name, address, mailing address, telephone number, e - mail
              address, credit card number, cardholder name, expiration date,
              information about the bookings bookings, co-passengers, and any
              and all details that may be requested while any customers visits
              or uses the website
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              When you browse the Website, indiaboats may collect information
              regarding the domain and host from which you access the Internet,
              the Internet Protocol address of the computer or Internet Service
              Provider you are using, and anonymous site statistical data. The
              Website uses cookie and tracking technology depending on the
              features offered. Personal Information will not be collected via
              cookies and other tracking technology; however, if you previously
              provided personally identifiable information, cookies may be tied
              to such information. Aggregate cookie and tracking information may
              be shared with third parties.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              We encourage you to review our Privacy Policy, and become familiar
              with it, but you should know that we do not sell or rent our
              customers' Personal Information to third parties.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              Please note that we review our Privacy Policy from time to time,
              and we may make periodic changes to the policy in connection with
              that review. Therefore, you may wish to bookmark this page and/or
              periodically review this page to make sure you have the latest
              version. Regardless of later updates, we will abide by the privacy
              practices described to you in this Privacy Policy at the time you
              provided us with your Personal Information.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              This Privacy Policy explains the following:
            </p>
            <ul
              type="disc"
              style={{
                listStyle: "none",
                paddingLeft: 0,
                fontSize: 13,
                color: "#6e7070"
              }}
            >
              <li>
                <a
                  style={{ color: "#6e7070" }}
                  href="http://www.makemytrip.com/legal/privacy_policy.html#personal_info_1"
                >
                  1. What Personal Information we collect from you and how we
                  use it?
                </a>
              </li>
              <li>
                <a
                  style={{ color: "#6e7070" }}
                  href="http://www.makemytrip.com/legal/privacy_policy.html#personal_info_2"
                >
                  2. With whom (if anyone) your Personal Information is shared?
                </a>
              </li>
              <li>
                <a
                  style={{ color: "#6e7070" }}
                  href="http://www.makemytrip.com/legal/privacy_policy.html#personal_info_3"
                >
                  3. How you can opt - out of receiving our promotional e -
                  mails?
                </a>
              </li>
              <li>
                <a
                  style={{ color: "#6e7070" }}
                  href="http://www.makemytrip.com/legal/privacy_policy.html#personal_info_4"
                >
                  4. What safeguards we have in place to protect your Personal
                  Information?
                </a>
              </li>
              <li>
                <a
                  style={{ color: "#6e7070" }}
                  href="http://www.makemytrip.com/legal/privacy_policy.html#personal_info_5"
                >
                  5. Other information you should know about your privacy?
                </a>
              </li>
            </ul>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              What Personal Information we collect from you and how we use it?
              <br />
              When browsing our Website, you are not required to provide any
              Personal Information unless and until you choose to make a
              purchase or sign up for one of our e-mail newsletters or other
              services as described below.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Making a purchase </strong>
              <br />
              In order to purchase travel and/or related services through our
              Website, you must provide us with certain Personal Information
              such as your name, credit card number and expiration date, credit
              card billing address, telephone number, e - mail address and the
              name or names of the person(s) traveling (if not you). We may also
              ask you for other Personal Information, such as your frequent
              traveler numbers. We require this information to process, fulfill
              and confirm your reservations and transactions and keep you
              informed of each transaction's status. If you are making a
              reservation for one or more travelers other than yourself, you
              must confirm and represent that each of these other travelers have
              agreed, in advance, that you may disclose their Personal
              Information to us.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Member Registration</strong>
              <br />
              If you choose to become a registered member of Website, you must
              provide your name, address, telephone number, e-mail address, a
              unique login name, password, and password validation, and a
              password hint to help you remember your password. This information
              is collected on the registration form for several reasons
              including but not limited to:
            </p>
            <ul
              type="disc"
              style={{
                listStyle: "none",
                paddingLeft: 0,
                fontSize: 13,
                color: "#6e7070"
              }}
            >
              <li>1. Personal identification</li>
              <li>2. To complete yacht booking, and other reservations</li>
              <li>
                3. To allow us to contact you for customer service purposes, if
                necessary
              </li>
              <li>
                4. To customize the content of our site to strive to meet your
                specific needs; and/or
              </li>
              <li style={{ lineHeight: "1.3" }}>
                5. To make product or other improvements to our site. In
                addition, we need your e - mail address to confirm your new
                member registration and each reservation you transact on our
                Website. As a Website member you will also occasionally receive
                updates from us about fare sales in your area, special offers,
                new IndiaBoats services, and other noteworthy items. However,
                you may choose at any time to no longer receive these types of e
                - mail messages. Please see our Opt - Out Policy described below
                for details.{" "}
              </li>
            </ul>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Member Profile</strong>
              <br />
              As a Website member, you can choose to complete your online
              profile by providing us with preferences, frequent – booking or
              affinity numbers, credit card billing information, paper ticket
              delivery address, and other Personal Information. This information
              is primarily used to assist you in making reservations quickly
              without having to type in the same information repeatedly. For
              example, you can store your frequent – boat bookings preferences
              so that when your make a reservation
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Online Surveys</strong>
              <br />
              IndiaBoats values opinions and comments from members, so we
              frequently conduct online surveys. Participation in these surveys
              is entirely optional. Typically, the information is aggregated,
              and used to make improvements to the Website and its services and
              to develop appealing content, features and promotions for Website
              members. Survey participants are anonymous unless otherwise stated
              in the survey.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Promotions &amp; Sweepstakes </strong>
              <br />
              IndiaBoats frequently sponsors promotions and sweepstakes to give
              Website members the opportunity to win great related prizes.
              Information collected by us for such activities may include
              contact information and survey questions. We use contact
              information to notify contest winners and survey information to
              develop promotions and product improvements to the Website.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Automatic Logging of Session Data</strong>
              We automatically log generic information about your computer's
              connection to the Internet, which we call "session data", that is
              anonymous and not linked to any Personal Information. Session data
              consists of things such as IP address, operating system and type
              of browser software being used and the activities conducted by the
              user while on the Website. An IP address is a number that lets
              computers attached to the internet, such as our web servers, know
              where to send data back to the user, such as the pages of the
              Website the user wishes to view. We collect session data because
              it helps us analyze such things as what items visitors are likely
              to click on most, the way visitors are clicking through the
              Website, how many visitors are surfing to various pages on the
              Website, how long visitors to the Website are staying and how
              often they are visiting. It also helps us diagnose problems with
              our servers and lets us better administer our systems. Although
              such information does not identify any visitor personally, it is
              possible to determine from an IP address a visitor's Internet
              Service Provider (ISP), and the approximate geographic location of
              his or her point of connectivity.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Cookies</strong>
              <br />
              "Cookies" are small pieces of information that are stored by your
              browser on your computer's hard drive. There are many myths
              circulating about cookies, but you should know that cookies are
              only read by the server that placed them, and are unable to do
              such things as run programs on your computer, plant viruses or
              harvest your Personal Information. The use of cookies is very
              common on the Internet and IndiaBoats use of cookies is similar to
              reputable online companies.
              <br />
              First and foremost, you can rest assured that no personally
              identifiable information ("PII") about you (e.g., name, address,
              etc.) is gathered or stored in the cookies placed by the Website
              and, as a result, none can be passed on to any third parties.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              Cookies allow us to serve you better and more efficiently, and to
              personalize your experience at our Website. IndiaBoats uses
              cookies to personalize your experience on the Website, and with
              respect to advertisements. As to the former, these types of
              cookies allow you to log in without having to type your log - in
              name each time (only your password is needed. We may also use such
              cookies to display an advertisement to you while you are on the
              Website or to send you a "Best Day to Buy" email (or similar
              emails - assuming you have not opted out of receiving such emails)
              focusing on destinations in which we think you might be
              interested. None of this information is passed to any third party,
              and is used solely by us to provide you with a better user
              experience on the Website.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              A cookie may also be placed by our advertising server. Such
              cookies are used only for purposes of tracking the effectiveness
              of advertising served by us on our Website and no PII is gathered
              from you by the use of these cookies, nor is this information
              shared with any third parties. Similarly, a cookie may be placed
              by our third - party advertising companies or advertisement
              providers or servers. These companies may use aggregated
              statistics about your visits to this and other websites in order
              to provide advertisements about Yachts - related goods and
              services that you may be interested in or any goods and services
              of potential interest to you. The information they collect does
              not include your PII.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              The third - party advertising companies or advertisement providers
              may also employ technology that is used to measure the
              effectiveness of ads. Any such information is anonymous. They may
              use this anonymous information about your visits to this and other
              sites in order to provide advertisements about goods and services
              of potential interest to you. No PII is collected during this
              process. The information is anonymous, and does not link online
              actions to an identifiable person. If you would like more
              information, and want to explore the option of not having this
              information collected by third - party advertisers.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              Most Web browsers automatically accept cookies. Of course, by
              changing the options on your web browser or using certain software
              programs, you can control how and whether cookies will be accepted
              by your browser. IndiaBoats supports your right to block any
              unwanted Internet activity, especially that of unscrupulous
              websites. However, blocking IndiaBoats cookies may disable certain
              features on the Website, and may make it impossible to purchase or
              use certain services available on the Website. Please note that it
              is possible to block cookie activity from certain websites while
              permitting cookies from websites you trust, like IndiaBoats
              Website.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              <strong>Other</strong>
              <br />
              From time to time we may add or enhance services available on the
              Website. To the extent these services are provided, and used by
              you, we will use the information you provide to facilitate the
              service requested. For example, if you email us with a question,
              we will use your email address, name, nature of the question, etc.
              to respond to your question. We may also store such information to
              assist us in making the Website the better and easier to use.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              With whom (if anyone) your Personal Information is shared?
              <br />
              When you reserve or purchase travel services through the Website,
              we must provide certain of your Personal Information to the Boat
              rental agency, F&amp;B services, hotel, car - rental agency,
              travel agency or other involved third party to enable the
              successful fulfilment of your services required. However, we do
              not sell or rent individual customer names or other Personal
              Information to third parties except sharing of such information
              with our alliance partners or vendors who are engaged by us for
              providing various promotional and other benefits to our customers
              from time to time basis their booking history with us. We use non
              - personally identifiable information in aggregate form to build
              higher quality, more useful online services by performing
              statistical analysis of the collective characteristics and
              behavior of our customers and visitors, and by measuring
              demographics and interests regarding specific areas of the
              Website. We may provide anonymous statistical information based on
              this data to suppliers, advertisers, affiliates and other current
              and potential Business partners. We may also use such aggregate
              data to inform these third parties as to the number of people who
              have seen and clicked on links to their websites. Occasionally,
              IndiaBoats will hire a third party to act on our behalf for
              projects such as market - research surveys and contest - entry
              processing and will provide information to these third parties
              specifically for use in connection with these projects. The
              information we provide to such third parties, alliance partners,
              or vendors are protected by a confidentiality agreement and is to
              be used solely for completing the specific project, and the usage
              of that information will be in compliance with the TRAI
              regulations.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              How you can opt-out of receiving our promotional e-mails?
              <br />
              At any time, you may unsubscribe from our Real Deals, Insider, or
              other newsletter or similar services through the "My Account" link
              on the Website home page. As a member or promotion/sweepstakes
              entrant, you will occasionally receive e-mail updates from us
              about fare sales in your area, special offers, new IndiaBoats
              services, and other noteworthy items. We hope you will find these
              updates interesting and informative. Of course, if you would
              rather not receive them, please click on the "unsubscribe" link or
              follow the instructions in each e - mail message or send us an
              email{" "}
              <a href="mailto:unsubscribe@IndiaBoats.in">
                unsubscribe@IndiaBoats.in
              </a>
              IndiaBoats reserves the right to limit membership to those who
              will accept e - mails. Members will be notified via e - mail prior
              to any actions taken.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              What safeguards we have in place to protect your Personal
              Information?
              <br />
              All payments on the Website is Verisign SSL secured. This means
              all Personal Information you provide on the Website is transmitted
              using SSL (Secure Socket Layer) encryption. SSL is a proven coding
              system that lets your browser automatically encrypt, or scramble,
              data before you send it to us. The same process happens when you
              make purchases on the Website.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              What other information should I know about my privacy?
              <br />
              Website contains links to other websites. Please note that when
              you click on one of these links, you are entering another website
              for which IndiaBoats has no responsibility. We encourage you to
              read the privacy statements of all such sites as their policies
              may be materially different from this Privacy Policy. Of course,
              you are solely responsible for maintaining the secrecy of your
              passwords, and your Website membership account information. Please
              be very careful, responsible, and alert with this information,
              especially whenever you're online.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              In addition to the circumstances described above, IndiaBoats may
              disclose the Website member information if required to do so by
              law, court order, as requested by other government or law
              enforcement authority, or in the good faith belief that disclosure
              is otherwise necessary or advisable including, without limitation,
              to protect the rights or properties of IndiaBoats or any or all of
              its affiliates, associates, employees, directors or officers or
              when we have reason to believe that disclosing the information is
              necessary to identify, contact or bring legal action against
              someone who may be causing interference with our rights or
              properties, whether intentionally or otherwise, or when anyone
              else could be harmed by such activities. In addition, if
              IndiaBoats or substantially all of its assets are acquired, our
              customer information will most likely also be transferred in
              connection with such acquisition
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              This policy is effective as of 01 Dec 2014 Any material changes in
              the way IndiaBoats uses Personal Information will be described in
              future versions of this Privacy Statement. Of course, you may
              always submit concerns regarding our Privacy Statement or our
              privacy practices via email to{" "}
              <a href="mailto:Customercare@indiaboat.in">
                Customercare@indiaboat.in
              </a>
              . Please reference the privacy policy in your subject line.
              IndiaBoats will attempt to respond to all reasonable concerns or
              inquiries within five business days of receipt.
            </p>
            <p style={{ margin: "10px 0", fontSize: 13 }}>
              Thank you for using the Website!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</>
<Footer/>
    </>
  );
};

export default Privacy;
